import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {GapFillingModel} from '../../models';
import {TeacherDndGapFilling} from './TeacherDndGapFilling';
import {TeacherKbtGapFilling} from './TeacherKbtGapFilling';

interface Props {
  x9: X9Content | X9ContentSnapshot
  store: X9ContentStateStore
}

@observer
export class TeacherGapFilling extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): GapFillingModel {
    return JSON.parse(this.props.x9.Contents) as GapFillingModel;
  }

  render() {
    const props = this.props;
    const model = this.model;
    const behavior = model.behavior;
    const id = props.x9.Id;

    if (behavior === 'drag-and-drop')
      return (
        <TeacherDndGapFilling id={id}
                              model={model}
                              store={props.store}/>);

    if (behavior === 'keyboard-type')
      return (
        <TeacherKbtGapFilling id={id}
                              model={model}
                              store={props.store}/>);

    return null;
  }
}
